import { useTranslation } from "react-i18next";

/**
 * Returns a currency formatter that adapts to the current i18n language.
 * - In FR : "12 250 FCFA"
 * - In EN : "12,250 XOF"
 */
export function useFmtXof() {
  const { i18n, t } = useTranslation();
  const isEn = (i18n.resolvedLanguage || i18n.language || "fr").startsWith("en");
  const locale = isEn ? "en-US" : "fr-FR";
  const suffix = t("common.fcfaSuffix");
  return (n) => `${Number(n || 0).toLocaleString(locale)} ${suffix}`;
}

/** Format a date string (yyyy-mm-dd or ISO) using current locale. */
export function useDateFmt() {
  const { i18n } = useTranslation();
  const locale = (i18n.resolvedLanguage || i18n.language || "fr").startsWith("en") ? "en-US" : "fr-FR";
  return (input) => {
    if (!input) return "";
    try { return new Date(input).toLocaleDateString(locale); } catch (e) { return String(input); }
  };
}
